import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isEmptyField } from 'src/app/main/shared/stock-chart-module/stock-chart/stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { RainfallForecastMapConstants } from './rainfall-forecast-map/rainfall-forecast-map-constants';
import { AgricultureMapConstants } from 'src/app/main/constants/dims-map-constants';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RainfallForecastDataService {
  sourceSelection: any;

  constructor(private http: HttpClient) { }

  getRainfallForecastData(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + 'weatherForecast/getTableData'
    return this.http.post<any>(url, postData)
  }

  getHeirarchy(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + "locations/heirarchy";
    return this.http.post<any>(url, postData)
  }

  getRainfallForecastChartData(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + "weatherForecast/getChartData";
    return this.http.post<any>(url, postData)
  }

  get24HrsTimeStamps() {
    // ---------------33435 IMD Block---------------
    let hoursIncrement = 0;
    let startHour = 8;
    // if (source == 'IMD') {
    //   hoursIncrement = ProjConstants.SOURCE_TIMESTAMP_DIFF.IMD;
    //   startHour = 8;
    // }
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(startHour, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blockIndex = Math.floor((refTs - dayStartTs) / 10800000);
    let startTimestamp = this.getCurrentBlockTs(dayStartTs)

    const blocks = {};
    for (let i = 0; i < 8; i++) {
      blocks[i] = {};
      // blocks[i]['timeStamp'] = dayStartTs + ((i + blockIndex) * 10800000);
      blocks[i]['timeStamp'] = startTimestamp + ((i * 10800000));
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['toolTip'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLineName']['label'] = this.convertTimestampToBlockValue(blocks[i]['timeStamp']);
      blocks[i]['leftSideName'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLinePos'] = i;
    }
    let index = this.getCurrentBlockIndex(blocks)
    // console.log("BLOCKS::",blocks,index);
    blocks[8] = {};
    blocks[8]['timeStamp'] = blocks[index]['timeStamp'];
    blocks[8]['timeLineName'] = {};
    blocks[8]['timeLineName']['toolTip'] = this.convertTimestampToBlockValue(blocks[index]['timeStamp']) + '-' + this.convertTimestampToBlockValue(blocks[index]['timeStamp']);
    blocks[8]['timeLineName']['label'] = '24hr';
    blocks[8]['leftSideName'] = '24hr';
    blocks[8]['timeLinePos'] = 8;
    return blocks;
  }

  get10DaysTimeStamps(source, timestamp) {
    let hoursIncrement = 0;
    let startHour;
    if (timestamp.endsWith('00')) {
      startHour = 8
    } else {
      startHour = 20
    }
    // if (source == 'IMD') {
    //   hoursIncrement = ProjConstants.SOURCE_TIMESTAMP_DIFF.IMD;
    //   startHour = 8;
    // }
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(startHour, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blocks = {};
    for (let i = 0; i < 7; i++) {
      blocks[i] = {};
      // blocks[i]['timeStamp'] = dayStartTs + ((i) * 86400000);
      blocks[i]['timeStamp'] = dayStartTs + ((i) * 86400000) - hoursIncrement;
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['label'] = this.convetTimeStampToDay(blocks[i]['timeStamp'] + hoursIncrement);
      blocks[i]['timeLineName']['toolTip'] = source == 'IMD' ? '8:30 AM - 8:30 AM' : '5:30 AM - 5:30 AM';
      blocks[i]['leftSideName'] = this.convetTimeStampToDay(blocks[i]['timeStamp'] + hoursIncrement);
      blocks[i]['timeLinePos'] = i;
    }
    return blocks;
  }

  convetTimeStampToDay(ts) {
    const date = new Date(ts).toLocaleDateString();
    return date;
  }

  getHeatMap(url) {
    let dataPromise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        data => {
          let obj = this.setMapData(data);
          resolve(obj);
        });
    });
    return dataPromise;
  }

  setMapData(data) {
    let obj = {};
    let imageUrl = {};
    let imageBounds = [];
    for (let block of Object.keys(data)) {
      for (let property of Object.keys(data[block])) {
        imageUrl = data[block]['heatMapImage'];
        let latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['southWest']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['southWest']['longitude']);
        imageBounds.push(latlongs);
        latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['northEast']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['northEast']['longitude']);
        imageBounds.push(latlongs);
      }
      obj['url'] = imageUrl;
      obj['bounds'] = imageBounds;
    }
    return obj;
  }

  getImageBounds(imageBounds) {
    const anchors = [];
    anchors.push([imageBounds[1][0], imageBounds[0][1]]);
    anchors.push([imageBounds[1][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[0][1]]);
    return anchors;
  }

  getForecastFileTimeStamp(primarySource, secondarySource) {
    let url = ProjConstants.API_URL + ProjConstants.API_MAPPING['FORECASTFILES'] + '/' + primarySource + "/" + secondarySource;
    let promise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe(data => {
        let max = data[primarySource];
        for (let source in data) {
          if (max == undefined || Number(data[source]) > max) {
            max = Number(data[source])
          }
        }
        resolve(max.toString())
      })
    })
    return promise
  }

  getCurrentBlockTs(dayStartTs) {
    let currentTs = new Date().getTime()
    let blockTs = dayStartTs;
    let timeStamp;
    for (let i = 0; i < 8; i++) {
      if (blockTs <= currentTs) {
        timeStamp = blockTs;
      } else {
        break;
      }
      blockTs = blockTs + 10800000;
    }
    return timeStamp

  }

  convertTimestampToFullBlockValue(ts) {
    ts = Number(ts);
    let starthours = new Date(ts).getHours();
    const startminutes = new Date(ts).getMinutes();
    let startamPm = 'A.M';
    if (starthours > 12) {
      starthours = starthours - 12;
      startamPm = 'P.M';
    }
    let endhours = new Date(ts + ProjConstants.MILLS_IN_3HOURS).getHours();
    const endminutes = new Date(ts + ProjConstants.MILLS_IN_3HOURS).getMinutes();
    let endamPm = 'A.M';
    if (endhours > 12) {
      endhours = endhours - 12;
      endamPm = 'P.M';
    }
    return starthours.toString() + ':' + startminutes.toString() + ' ' + startamPm + ' - ' + endhours.toString() + ':' + endminutes.toString() + ' ' + endamPm;
  }

  convertTimestampToBlockValue(ts) {
    ts = Number(ts);
    let hours = new Date(ts).getHours();
    const minutes = new Date(ts).getMinutes();
    let amPm = 'A.M';
    if (hours > 12) {
      hours = hours - 12;
      amPm = 'P.M';
    }
    return hours.toString() + ':' + minutes.toString() + ' ' + amPm;
  }

  getCurrentBlockIndex(blocks) {
    const currentTime = new Date().getTime();
    let currentBlockIndex: any = 0; // Default value if not found

    for (const index in blocks) {
      const blockStartTime = blocks[index].timeStamp;
      const blockEndTime = blockStartTime + 3 * 60 * 60 * 1000; // 3 hours in milliseconds

      if (currentTime >= blockStartTime && currentTime < blockEndTime) {
        currentBlockIndex = index;
        break;
      }
    }

    return currentBlockIndex;
  }

  deepClone(object: any): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj: any = {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }

  getUpdatePostData(queryParams) {
    this.sourceSelection = queryParams['source'] == 'IMD_SHORT_RANGE' ? 'IMD_LONG_RANGE' : queryParams['source']
    let postData: any
    let allLocations = queryParams.location.split('&')
    let stateUUID;
    if (queryParams.locType == 'DISTRICT') {
      stateUUID = allLocations[1].split('##')[1]
    }
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(queryParams.locType) + 1];
    let firstLevel: any = hie[hie.indexOf(queryParams.locType) - 1];
    const refDate = new Date();
    refDate.setHours(8, 30, 0, 0);
    let refTs = refDate.getTime();
    if (queryParams.locType == 'COUNTRY' || queryParams.locType == 'STATE') {
      postData = {
        "primarySource": queryParams['source'],
        "secondarySource": this.sourceSelection,
        "sUUID": queryParams.pUUID,
        "component": "RAINFALL",
        "pUUID": queryParams.pUUID,
        "pType": queryParams.locType,
        "forecastLength": queryParams.forecastLength,
        "view": "Admin",
        "cType": currentLevel,
        "refTs": refTs
      }
    } else {
      postData = {
        "parentUUID": stateUUID,
        "primarySource": queryParams['source'],
        "secondarySource": this.sourceSelection,
        "view": "Admin",
        "pType": queryParams.locType,
        "sUUID": stateUUID,
        "component": "RAINFALL",
        "locationType": queryParams.locType,
        "forecastLength": queryParams.forecastLength,
        "refTs": refTs,
        "pUUID": queryParams.pUUID,
        "cType": currentLevel
      }
    }
    return postData;
  }

  getChartData(formattedChartData: any[], params: any): any {
    // let locType = params['locType'] !== 'STATE' ? 'Districts' : 'Blocks';
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(params.locType) - 1];
    let firstLevel: any = hie[hie.indexOf(params.locType) + 1];
    let locType = firstLevel.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

    if (!formattedChartData || formattedChartData.length === 0) {
      return {}; // return empty if no data
    }

    // Extract timestamps (keys except "Rainfall Band")
    // const timestamps = Object.keys(formattedChartData[0]).filter(key => key !== "Rainfall Band");
    const timestamps = Object.keys(formattedChartData[0]).filter(key => key !== "Rainfall Band").sort((a, b) => Number(a) - Number(b));

    // Format timestamps to readable time like "08:30"
    // const categories = timestamps.map(ts => {
    //   const date = new Date(Number(ts));
    //   const hours = date.getHours().toString().padStart(2, '0');
    //   const minutes = date.getMinutes().toString().padStart(2, '0');
    //   return `${hours}:${minutes}`;
    // });
    let categories: any;
    if (params.forecastLength == '24') {
      // if(entry.blockLength == '3hr'){
        categories = timestamps.map(ts => {
          if (ts === "24hr") {
            return "24hr";
          } else {
            const date = new Date(Number(ts));
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
          }
        });
      // }
    } else if (params.forecastLength == '10') {
      categories = timestamps.map(ts => {
        console.log(ts, "tsssss")
        const date = new Date(Number(ts));
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        console.log(day, month, year, "tear123");
        return `${day}/${month}/${year}`;
      });
    }

    const colorMap: { [key: string]: string } = {
      "no rainfall": "#ffffff",
      "very light rainfall": "#C3FDCA",
      "light rainfall": "#00FE08",
      "moderate rainfall": "#038500",
      "heavy rainfall": "#FDBFC9",
      "very heavy rainfall": "#FC0300",
      "extremely heavy rainfall": "#610301"
    };

    const labelMap: { [key: string]: string } = {
      "no rainfall": "no rainfall (0.0 - 0.51 mm/hr)",
      "very light rainfall": "very light rainfall (0.51 - 1.1 mm/hr)",
      "light rainfall": "light rainfall (1.1 - 4.1 mm/hr)",
      "moderate rainfall": "moderate rainfall (4.1 - 16.1 mm/hr)",
      "heavy rainfall": "heavy rainfall (16.1 - 30.1 mm/hr)",
      "very heavy rainfall": "very heavy rainfall (30.1 - 50.1 mm/hr)",
      "extremely heavy rainfall": "extremely heavy rainfall (>50.1 mm/hr)"
    };
    // Dynamically generate series for each Rainfall Band
    const series = formattedChartData.map(item => ({
      // name: item["Rainfall Band"],
      name: labelMap[item["Rainfall Band"]] || item["Rainfall Band"],
      type: 'column',
      data: timestamps.map(ts => item[ts] || 0),
      color: colorMap[item["Rainfall Band"]] || "#808080" // default color if not found
    }));

    const chartOptions = {
      chart: {
        type: 'column',
        backgroundColor: '#000000'
      },
      title: {
        text: '',
        style: { color: '#ffffff' }
      },
      xAxis: {
        categories: categories,
        labels: {
          style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', }
        },
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: `No of ${locType}`,
          style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',}
        },
        labels: {
          style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', }
        },
        gridLineColor: '#808080'
      },
      legend: {

        layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom',
  itemMarginTop: 4,
  itemMarginBottom: 4,
  symbolRadius: 0,
        itemStyle: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
            fontSize: '8px',
    fontWeight: 'normal'
           }
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true
          }
        }
      },
      series: series,
      credits: {
        enabled: false
      }
    };

    return chartOptions;
  }


  getRfForecastChartData(formattedChartData: any[]): any {
    if (!formattedChartData || formattedChartData.length === 0) {
      return {};
    }
    const timestamps = Object.keys(formattedChartData[0]).filter(key => key !== "Rainfall Band").sort((a, b) => Number(a) - Number(b));
    let categories: any;
    categories = timestamps.map(ts => {
      if (ts === "24hr") {
        return "24hr";
      } else {
        const date = new Date(Number(ts));
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      }
    });
    const colorMap: { [key: string]: string } = {
      "no rainfall": "#ffffff",
      "very light rainfall": "#C3FDCA",
      "light rainfall": "#00FE08",
      "moderate rainfall": "#038500",
      "heavy rainfall": "#FDBFC9",
      "very heavy rainfall": "#FC0300",
      "extremely heavy rainfall": "#610301"
    };

    // Dynamically generate series for each Rainfall Band
    const series = formattedChartData.map(item => ({
      name: item["Rainfall Band"],
      // type: 'column',
      type: 'spline',
      data: timestamps.map(ts => item[ts] || 0),
      color: colorMap[item["Rainfall Band"]] || "#808080" // default color if not found
    }));

    const chartOptions = {
      chart: {
        // type: 'column',
        type: 'spline',
        height: 280,
        backgroundColor: '#404040'
      },
      title: {
        text: '',
        style: { color: '#ffffff' }
      },
      xAxis: {
        categories: categories,
        labels: {
          style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', }
        },
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: `No of States`,
          style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', }
        },
        labels: {
          style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',}
        },
        gridLineColor: '#808080'
      },
      legend: {

         layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom',
  itemMarginTop: 4,
  itemMarginBottom: 4,
  symbolRadius: 0,
        itemStyle: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
            fontSize: '8px',
    fontWeight: 'normal'
           },
        title: {
          text: '',
          style: { color: '#ffffff', fontWeight: 'bold' }
        }
      },
      tooltip: {
        shared: true,
        backgroundColor: '#1e1e1e',
        borderColor: '#666',
        style: { color: '#fff' },
        headerFormat: '<b>{point.key}</b><br/>',
        pointFormat:
          '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>'
      },
      // plotOptions: {
      //   column: {
      //     stacking: 'normal',
      //     // dataLabels: {
      //     //   enabled: true
      //     // }
      //   }
      // },
      plotOptions: { spline: { dataLabels: { enabled: false }, enableMouseTracking: true } },
      // series: series.map(s => ({ ...s, type: 'spline' })),
      series: series,
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      }
    };

    return chartOptions;
  }

  setChartData(data, ProjConstants) {
    const keys = Object.keys(data);
    const formattedChartData = [];
    for (const key of keys) {
      const obj = {};
      for (const item of Object.keys(data[key])) {

        if (item == '6hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        } else if (item == '24hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj['24hr'] = data[key][item][timestamp];
          }
        } else {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        }
      }
      obj[ProjConstants.CHART_DATA_COLUMNS['RAINFALL']] = key;
      formattedChartData.push(obj);
    }
    return formattedChartData;
  }

  setRainfallcolor(value1) {
    let value: string = value1;
    value = value.toString().replace(",", "");
    let obj;
    if (value == 'no rain') {
      obj = { 'textcolor': '#5e594e', 'bgcolor': '#ffffff', 'col': 'color1' }
    }
    else if (value == 'light rain') {
      obj = { 'textcolor': '#5e594e', 'bgcolor': '#00FE08', 'col': 'color2' }
    }
    else if (value == 'moderate rain') {
      obj = { 'textcolor': '#ffffff', 'bgcolor': '#038500', 'col': 'color3' }
    }
    else if (value == 'heavy rain') {
      obj = { 'textcolor': '#5e594e', 'bgcolor': '#FDBFC9', 'col': 'color4' }
    }
    else {
      obj = { 'textcolor': '#ffffff', 'bgcolor': '#610301', 'col': 'color7' }
    }
    return obj;
  }
}
